import useUserStore from '@/store/userStore';

export const TIER_LIMITS: Record<string, Record<string, number>> = {
  trial: {
    'why_this_chart': 2,
    'max_dashboard_charts': 12,
  },
  lite: {
    'max_dashboard_charts': 12,
  },
  daily: {
    'max_dashboard_charts': 12,
  },
  standard: {
    'max_dashboard_charts': 12,
  },
  premium: {
    'max_dashboard_charts': 12,
  },
  enterprise: {
    'max_dashboard_charts': 12,
  },
};

export const isFeatureRestricted = (tier: string | null | undefined, featureId: string): boolean => {
  const featureAccess = (useUserStore.getState()?.featureAccess || {}) as Record<string, unknown>;

  // If the feature exists in the backend response, return true if restricted (!is_allowed)
  if (featureAccess[featureId] !== undefined) {
      const val = featureAccess[featureId];
      if (typeof val === 'string') return val.toLowerCase() !== 'true' && val !== '1';
      if (typeof val === 'number') return val !== 1;
      return !val;
  }
  
  // Default fallback if featureAccess hasn't loaded yet or is empty
  const actualTier = tier || 'trial';
  const defaultRestricted: Record<string, string[]> = {
    trial: ['shared_dashboard_links', 'download_insights_report'],
  };
  return defaultRestricted[actualTier.toLowerCase()]?.includes(featureId) ?? false;
};

export const getFeatureLimit = (tier: string | null | undefined, featureId: string): number => {
  const actualTier = tier || 'trial';
  return TIER_LIMITS[actualTier.toLowerCase()]?.[featureId] ?? Infinity;
};
